module.exports = __webpack_public_path__ + "bad83518171014344599097b915901d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/unavailable.png
// module id = 229
// module chunks = 0